import { useMutation } from 'react-query';
import { useStore } from '../../../context';
import { Actions } from '../../../store';
import { authService } from '../../../services';
import { signinRolesValue } from '../../../const';

const getNormalUser = (user: any) => {
  if (user.yardCompanyEmployee) {
    user.type = signinRolesValue[user.yardCompanyEmployee.role];
  }
  if (user.yardEmployee) {
    user.type = signinRolesValue[user.yardEmployee.role];
  }
  if (user.clientEmployee) {
    user.type = signinRolesValue[user.clientEmployee.role];
  }

  return user;
};

const getSigninProps = () => {
  const email: any = undefined;

  let userBase: any = localStorage.getItem('user');
  userBase = !userBase ? null : JSON.parse(userBase);

  const hasClientInfo =
    (!!userBase?.clientEmployee &&
      !!userBase?.clientEmployee?.client?.code &&
      !!userBase?.clientEmployee?.client?.category) ||
    !userBase?.clientEmployee;
  const hasYardInfo =
    (!!userBase?.yardEmployee && typeof userBase?.yardEmployee?.canCreateClient === 'boolean') ||
    !userBase?.yardEmployee;
  const hasAllRolesInfo = typeof userBase?.canTrade === 'boolean';
  const hasFullUserInfo = hasClientInfo && hasYardInfo && hasAllRolesInfo;
  const hasAccessRole = userBase?.type !== 'YARD_CRANE_OPERATOR';

  const isAccessAllowed = userBase && hasFullUserInfo && hasAccessRole;

  return { userBase, email, hasAccessRole, isAccessAllowed };
};

export const useSigninMutation = () => {
  const { dispatch } = useStore();
  const { hasAccessRole, isAccessAllowed } = getSigninProps();
  let { userBase, email } = getSigninProps();

  return useMutation(
    (props: any = {}) => {
      if (isAccessAllowed) return Promise.resolve({ data: { data: userBase } } as any);
      if (!props.email || !hasAccessRole) return Promise.reject();

      email = props.email;
      return authService.signin(props);
    },
    {
      onSuccess: (res: any) => {
        if (res && !userBase) {
          userBase = getNormalUser({
            ...res.data.data,
            email,
            type: res.data.data.belongsTo,
          });

          localStorage.setItem('user', JSON.stringify(userBase));
        }

        dispatch({ type: Actions.SET_USER_DATA, payload: userBase });

        return res;
      },
      onError: () => {
        localStorage.removeItem('user');
      },
    },
  );
};

export const useForgotPasswordMutation = () => {
  return useMutation(authService.forgotPassword);
};

export const useCreateNewPasswordMutation = () => {
  return useMutation(authService.createNewPassword);
};

export const useUpdatePasswordMutation = () => {
  return useMutation(authService.updatePassword);
};

export const useLogoutMutation = () => {
  return useMutation(authService.logout);
};
